import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Authenticator } from "@aws-amplify/ui-react";
import { AppThemeOptions } from "./AppThemeOptions";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const hasLocalhost = (hostname: any) =>
  Boolean(
    hostname.match(/localhost/) ||
      hostname.match(/127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}/)
  );

const isLocalHost = hasLocalhost(window.location.hostname);

/*
const darkThemeOptions = {
  ...AppThemeOptions,
  palette: {
    ...AppThemeOptions.palette,
    mode: "dark",
    primary: {
      //main: "#2487D8", // blue
      main: "#90caf9", // light blue
    },
    secondary: {
      main: "#f48fb1", // light pink
    },
    background: {
      default: "#303030", // dark grey
      paper: "#424242", // slightly lighter grey
    },
    text: {
      primary: "#ffffff", // white
      secondary: "#bdbdbd", // light grey
    },
  },
};
*/

const darkThemeOptions = {
  ...AppThemeOptions,
  palette: {
    ...AppThemeOptions.palette,
    mode: "dark",
    primary: {

      main: "#90caf9", // light blue
    },
    secondary: {
      main: "#f48fb1", // light pink
    },
    background: {
      default: "#010101", 
      paper: "#111111", 
    },
    text: {
      primary: "#cccccc", // white
      secondary: "#bdbdbd", // light grey
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#333333", // Darker background color for normal buttons
          color: "#ffffff", // White text color
          '&:hover': {
            backgroundColor: "#555555", // Slightly lighter on hover
          },
        },
        outlined: {
          borderColor: "#333333", // Border color for outlined buttons
          color: "#ffffff", // White text color
          backgroundColor: "#111111", // Darker background color for outlined buttons
          '&:hover': {
            backgroundColor: "#555555", // Slightly lighter on hover
            borderColor: "#555555", // Border color on hover
          },
        },
        text: {
          border: "none", // No border
          color: "#ffffff", // White text color
          backgroundColor: "transparent", // No background color
          '&:hover': {
            backgroundColor: "transparent", // No background color on hover
            color: "#90caf9", // Change text color on hover
          },
        },
      },
    },
  },
};

const lightThemeOptions = {
  ...AppThemeOptions,
  palette: {
    ...AppThemeOptions.palette,
    mode: "light",

    background: {
      paper: "#f5f5f5", // white
    },
  },
};

const THEME_KEY = "_llmasaservice_theme";
const userThemePreference = localStorage.getItem(THEME_KEY) || "dark";

const themeOptions =
  userThemePreference === "dark" ? darkThemeOptions : lightThemeOptions;

const theme = createTheme(themeOptions as any);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        {/*<ReactQueryDevtools initialIsOpen={false} />*/}
        <BrowserRouter>
          <Authenticator.Provider>
            {/*<ReactQueryDevtools initialIsOpen={false} />*/}
            <App />
          </Authenticator.Provider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
